import React from "react"
import DayPickerInput from "react-day-picker/DayPickerInput"
import "react-day-picker/lib/style.css"
import dayjs from "dayjs"
import { DailyQuickView } from "./DailyQuickView"
import "../utils/daypicker.css"

export default class DayPickerInputComp extends React.Component<{
  model: DailyQuickView
}> {
  render() {
    const { model } = this.props
    const FORMAT = "MMM DD, YYYY"

    return (
      <DayPickerInput
        selectedDays={model && model.currentDate.toDate()}
        onDayChange={(day: Date) => {
          model.currentDate = dayjs(day)
        }}
        format={FORMAT}
        parseDate={model && model.parseDate}
        placeholder={`${dayjs(model.currentDate).format(FORMAT)}`}
        inputProps={{ style: { fontSize: "1.2rem", textAlign: "center" } }}
        dayPickerProps={{
          month: model.currentDate.toDate(),
          todayButton: "Today"
        }}
      />
    )
  }
}
